import { toast } from "react-toastify";
import { FetchTenderByIdDocument, UnarchiveTenderDocument, UnarchiveTenderMutation, UnarchiveTenderMutationVariables } from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";

export default function useUnarchiveTenderMutationHook() {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [unarchiveTenderMutation, { loading, error }] = useMutation<UnarchiveTenderMutation, UnarchiveTenderMutationVariables>(UnarchiveTenderDocument, {
    onCompleted() {
      toast(CustomToastComponent, {
        toastId: "tender-unarchived-success",
        data: {
          title: t("toasts.tenderunarchivedsuccessfully"),
          type: "success",
        }
      });
    },
    refetchQueries: [
      {
        query: FetchTenderByIdDocument,
        variables: { id: Number(tenderID) }
      }
    ]
  });

  return {
    unarchiveTenderMutation,
    loading,
    error
  };
}
